import { Check, Copy } from "lucide-react";
import { FormEvent, useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { useGerarLink } from "../hooks/use-suporte";
import { horaMensagem } from "./format";

interface GerarLinkDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onGerado: (ticketId: string) => void;
}

export function GerarLinkDialog({ open, onOpenChange, onGerado }: GerarLinkDialogProps) {
  const [telefone, setTelefone] = useState("");
  const [ops, setOps] = useState("");
  const [copiado, setCopiado] = useState(false);
  const gerar = useGerarLink();
  const link = gerar.data?.data;

  const fechar = (aberto: boolean) => {
    if (!aberto) {
      gerar.reset();
      setCopiado(false);
    }
    onOpenChange(aberto);
  };

  const submit = (e: FormEvent) => {
    e.preventDefault();
    setCopiado(false);
    gerar.mutate(
      { telefone, opsEntregador: ops.trim().toLowerCase() },
      { onSuccess: (res) => onGerado(res.data.ticket_id) }
    );
  };

  const copiar = async () => {
    if (!link) return;
    await navigator.clipboard.writeText(link.url);
    setCopiado(true);
  };

  return (
    <Dialog open={open} onOpenChange={fechar}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Gerar link de suporte</DialogTitle>
          <DialogDescription>
            Se o entregador já tiver um atendimento aberto, o link leva para ele. A validade aparece depois de gerar.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label htmlFor="suporte-telefone">Telefone</Label>
              <Input
                id="suporte-telefone"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                placeholder="(11) 99999-8888"
                required
              />
            </div>
            <div className="space-y-1">
              <Label htmlFor="suporte-ops">Ops do entregador</Label>
              <Input
                id="suporte-ops"
                value={ops}
                onChange={(e) => setOps(e.target.value)}
                placeholder="imile"
                required
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={gerar.isPending}>
              {gerar.isPending ? "Gerando…" : "Gerar link"}
            </Button>
          </DialogFooter>
        </form>

        {link && (
          <div className="space-y-2 rounded-md border bg-muted/40 p-3">
            <div className="flex gap-2">
              <Input readOnly value={link.url} onFocus={(e) => e.target.select()} className="font-mono text-xs" />
              <Button type="button" variant="outline" onClick={copiar}>
                {copiado ? <Check /> : <Copy />} {copiado ? "Copiado" : "Copiar"}
              </Button>
            </div>
            <p className="text-xs text-muted-foreground">
              {link.reused ? "Atendimento já aberto reaproveitado" : "Novo atendimento criado"} · expira{" "}
              {horaMensagem(link.expires_at)}
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
